import * as React from 'react';
import { useRecordContext } from "./useRecordContext.js";
/**
 * Render prop version of useRecordContext
 *
 * @example
 * const BookShow = () => (
 *    <Show>
 *       <SimpleShowLayout>
 *          <WithRecord render={record => <span>{record.title}</span>} />
 *      </SimpleShowLayout>
 *   </Show>
 * );
 */
export var WithRecord = function (_a) {
    var render = _a.render, _b = _a.empty, empty = _b === void 0 ? null : _b;
    var record = useRecordContext();
    return record ? React.createElement(React.Fragment, null, render(record)) : empty;
};
//# sourceMappingURL=WithRecord.js.map